<div class="page-title">
  <h1>Módulos</h1>
</div>

<!-- Loading -->
<div class="loading" *ngIf="isLoading">
  <mat-spinner diameter="40"></mat-spinner>
</div>

<!-- Erro -->
<div class="erro-msg" *ngIf="erro && !isLoading">
  <p>{{ erro }}</p>
  <button class="btn-cheio" (click)="carregarModulos()">Tentar novamente</button>
</div>

<!-- Grid de módulos -->
<div class="modulos-grid" *ngIf="!isLoading && !erro">
  <div class="modulo-card" *ngFor="let modulo of modulos">

    <div
      class="modulo-imagem"
      [style.background-image]="modulo.imagemUrl ? 'url(' + modulo.imagemUrl + ')' : 'none'"
    ></div>

    <div class="modulo-info">
      <h2 class="modulo-titulo">{{ modulo.nome }}</h2>
      <p class="modulo-subtitulo">{{ modulo.linhaDeCuidadoNome }}</p>
      <p class="modulo-descricao">{{ modulo.descricao }}</p>
    </div>

    <div class="modulo-acoes">
      <button class="btn-cheio" (click)="editarModulo(modulo)">
        Editar módulo
      </button>
    </div>

  </div>

  <p class="sem-modulos" *ngIf="modulos.length === 0">
    Nenhum módulo encontrado.
  </p>
</div>